import { Lib } from "albertine-shared-web";
import type { ReactNode } from "react";
import { useNavigateBack } from "@/shared/hooks/useNavigateBack";
import { useScrollIsOnTop } from "@/shared/hooks/useScrollIsOnTop";

type StickyHeaderProps = {
    title: string;
    variant: "article" | "booking";
    backButton?: ReactNode;
    shareButton?: ReactNode;
};

export function StickyHeader({
    title,
    variant,
    backButton,
    shareButton,
}: StickyHeaderProps) {
    const onTop = useScrollIsOnTop();
    const backgroundClassName =
        variant === "article"
            ? "bg-background-discover-secondary"
            : "bg-background-booking-secondary";
    const titleMaxWidthClassName = shareButton
        ? "max-w-[min(400px,calc(100%-160px))] md:max-w-[600px]"
        : "max-w-[min(400px,calc(100%-80px))] md:max-w-[600px]";

    return (
        <div
            className={`fixed top-0 z-20 w-full pt-(--twsa-safe-area-inset-top) transition-all duration-300 ease-in-out ${backgroundClassName} ${
                onTop
                    ? "invisible -translate-y-[60px] opacity-0"
                    : "visible translate-y-0 opacity-100"
            }`}
        >
            <div className="flex items-center justify-center px-16 py-16">
                {backButton}
                <Lib.Heading.H5
                    className={`mx-16 overflow-hidden text-ellipsis whitespace-nowrap ${titleMaxWidthClassName}`}
                >
                    {title}
                </Lib.Heading.H5>
                {shareButton}
            </div>
        </div>
    );
}

export function StickyHeaderBackButton() {
    const handleBack = useNavigateBack();

    return (
        <Lib.Button.Ghost
            onClick={handleBack}
            className="absolute left-0 z-10 px-16 py-12"
            aria-label="Go back"
        >
            <Lib.Icon.ArrowBack.Medium />
        </Lib.Button.Ghost>
    );
}
